export enum MasterCalendarLegendItemWrapperBlock {
  Root = 'MasterCalendarLegendItemWrapper',
}
